import { create } from 'zustand';
import { adminCan } from '@shripos/shared/constants';

/**
 * Admin session state. Cookies hold the actual credentials (httpOnly); this only mirrors
 * who is signed in, plus the short-lived MFA step between password and TOTP.
 */
export const useSession = create((set, get) => ({
  status: 'loading', // loading | authenticated | anonymous
  admin: null,
  signedOutReason: null, // 'idle' | 'expired' | 'logout'
  mfa: null, // { token, stage: 'enroll' | 'verify', email }

  signedIn: (admin) => set({ status: 'authenticated', admin, mfa: null, signedOutReason: null }),
  signedOut: (reason = null) => {
    if (get().status === 'anonymous' && !reason) return;
    set({ status: 'anonymous', admin: null, mfa: null, signedOutReason: reason });
  },
  startMfa: (mfa) => set({ mfa }),
  can: (permission) => adminCan(get().admin?.role, permission),
}));

export function useCan(permission) {
  return useSession((s) => adminCan(s.admin?.role, permission));
}
